import { render, staticRenderFns } from "./SelectEnterSectionTicketsAmount.vue?vue&type=template&id=3296f2f4&"
import script from "./SelectEnterSectionTicketsAmount.vue?vue&type=script&lang=js&"
export * from "./SelectEnterSectionTicketsAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports